<template>
  <div class="FormReviewExternal">
    <RowGrid :columns="2">
      <Field
        :label="$t('url')"
        :value="reviewExternal.url"
        @update:value="setUrl">
        <FieldBtns v-if="canFetch">
          <FieldBtn
            class="success"
            :isLoading="isLoading"
            @click="$emit('fetchMerge', [reviewExternal])">
            {{ $t('fetchMerge') }}
          </FieldBtn>
          <FieldBtn
            :isLoading="isLoading"
            @click="$emit('fetch', [reviewExternal])">
            {{ $t('fetch') }}
          </FieldBtn>
        </FieldBtns>
      </Field>
      <Field
        :label="$t('title')"
        :value.sync="reviewExternal.title" />
    </RowGrid>
    <RowGrid :columns="3">
      <Field
        :label="$t('summary')"
        type="textarea"
        :value.sync="reviewExternal.summary" />
      <FieldList
        :items.sync="reviewExternal.pros"
        :label="$t('pros')"
        @add="reviewExternal.pros.push(null)" />
      <FieldList
        :items.sync="reviewExternal.cons"
        :label="$t('cons')"
        @add="reviewExternal.cons.push(null)" />
    </RowGrid>
    <RowGrid :columns="3">
      <Field
        :label="$t('siteName')"
        :value.sync="reviewExternal.siteName" />
      <Field
        :label="$t('authorName')"
        :value.sync="reviewExternal.authorName" />
      <Field
        :label="$t('reviewedAt')"
        :value.sync="reviewExternal.reviewedAt" />
    </RowGrid>
    <div v-if="reviewExternal.laptop">
      <div>
        <Btn class="ib sm light" @click="doShowDiff = !doShowDiff">
          {{ $t('compare') }}
        </Btn>
      </div>
      <DiffLaptops
        v-if="doShowDiff"
        :incoming="reviewExternal.laptop"
        :original="laptopParent" />
    </div>
  </div>
</template>

<script>
import DiffLaptops from '@components/DiffLaptops'
import FieldList from '@forms/FieldList'
import { getHostname } from '@utils/strings'
import implySiteName from '../implySiteName'

export default {
  components: {
    DiffLaptops,
    FieldList,
  },
  props: {
    isLoading: { type: Boolean, default: false },
    laptopParent: { type: Object, required: true },
    reviewExternal: { type: Object, required: true },
  },
  data() {
    return {
      doShowDiff: false,
    }
  },
  computed: {
    canFetch() {
      const { url } = this.reviewExternal

      if (!url) return false

      const hostname = getHostname(url)

      return [
        'everymac.com',
        'www.cnet.com',
        'www.laptopmag.com',
        'www.notebookcheck.net',
        'www.pcmag.com',
        'www.rtings.com',
        'www.techradar.com',
        'www.tomsguide.com',
        'www.tomshardware.com',
        'www.ultrabookreview.com',
      ].includes(hostname)
    },
  },
  methods: {
    setUrl(url) {
      const { reviewExternal } = this

      reviewExternal.url = url

      const siteName = implySiteName(url)

      if (siteName && !reviewExternal.siteName) {
        reviewExternal.siteName = siteName
      }
    },
  },
}
</script>

<style lang="scss">
.FormReviewExternal {
}
</style>

<i18n>
{
  "en": {
    "title": "Title",
    "siteName": "Site name",
    "authorName": "Author name",
    "reviewedAt": "Reviewed at",
    "summary": "Summary",
    "pros": "Pros",
    "cons": "Cons",
    "url": "Link",
    "compare": "Compare",
    "fetch": "Fetch",
    "fetchMerge": "Fetch & Merge"
  }
}
</i18n>
